module.exports = __webpack_public_path__ + "assets/img/face_contrast_describe.6c86c90c.png";